import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TasksRoutingModule } from './tasks-routing.module';
import { TaskDetailComponent } from './task-detail/task-detail.component';
import { TaskEntryComponent } from './task-entry/task-entry.component';
import { PipeModuleModule } from '../pipe/pipe-module/pipe-module.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TaskListComponent } from './task-list/task-list.component';
import { TaskReportComponent } from './task-report/task-report.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { AllTaskReportComponent } from './all-task-report/all-task-report.component';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MatNativeDateModule, MatOptionModule, MatRippleModule, MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

@NgModule({
  declarations: [
    TaskEntryComponent,
    TaskDetailComponent,
    TaskListComponent,
    TaskReportComponent,
    AllTaskReportComponent
  ],
  imports: [
    CommonModule,
    TasksRoutingModule,
    PipeModuleModule,
    NgxSpinnerModule,
    ReactiveFormsModule,
    FormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatAutocompleteModule
  ],

  entryComponents: [TaskEntryComponent],

  providers: [
    NgbActiveModal,
    { provide: MAT_DATE_LOCALE, useValue: 'en-IN' }, {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },



  ]
})
export class TasksModule { }
